import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { DEMO } from "../../../../config/constant";
import IdCardCapture from "./IdCardCapture";
import SelfieCapture from "./SelfieCapture";
// import {  setIdCardImage, setIdCardImageBack } from '../../../action/autoCheckin';
import { CMSPath } from "../../../../config/constant";
import { setGoHome } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../../action/hCommerce2";
import { setAbortCheckinProcess, setCheckinCurrentPageName, setSelectedIdType, setSelfieVideo } from "../../../action/autoCheckin";
import { setIdCardImage, setIdCardImageBack } from "../../../action/autoCheckin";
import { withTranslation } from "react-i18next";
import { scrollToTop } from "../../../../JS/scrollToTop";
import Camera from "../Camera";
import { getDefaultAnalyticsLabel } from "../../../JS/utility";
import { sendAnalytics } from "../../../../action/homeAction";

export function Cross_svg() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M9 3L3 9M3 3L9 9" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}


export function Tick_svg() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}

export function Arrow_svg() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}


// for now let NO CLEAR VERIFICATION
function ScanIdandSelfieTogether(props) {
    const { t } = props;

    const [showCameraPrevForId, setShowCameraPrevForId] = useState(false);
    const [showCameraPrevForSelfie, setShowCameraPrevForSelfie] = useState(false);

    const [takingBackID, setTakingBackId] = useState(false);
    const [mediaFiles, setMediaFiles] = useState({
        idImageURI: "",
        idImageBackURI: "",
        selfiURI: "",
        selfieFiles: []
    })


    const goBack = () => {
        props.setSelectedIdType(null);
        props.setIdCardImage(null)
        props.setIdCardImageBack(null)
        props.setSelfieVideo(null);
        props.goBack()
    }

    const openCameraPrev = (isIdVerification, isSelfieVerification) => {

        const checkinSessionToken = localStorage.getItem("checkinSessionToken");
        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

        if (isIdVerification) {

            const checkin_id_capture_event_sent = localStorage.getItem("checkin_id_capture_event_sent");
            // Send Analytics
            if (!checkin_id_capture_event_sent) {
                props.sendAnalytics(
                    null, // as no guesdetails in logout state 
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "ID CARD - CAPTURE",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "ID CARD - CAPTURE", "widgetSessionId": checkinSessionToken },
                    0,
                    false, // guest is not logged in
                    () => localStorage.setItem("checkin_id_capture_event_sent", true)
                );
            }
            props.setCheckinCurrentPageName("ID CARD - CAPTURE")

            setShowCameraPrevForId(true);
            setShowCameraPrevForSelfie(false);
            return;
        }

        if (isSelfieVerification) {

            const checkin_selfie_capture_event_sent = localStorage.getItem("checkin_selfie_capture_event_sent");
            // Send Analytics
            if (!checkin_selfie_capture_event_sent) {
                props.sendAnalytics(
                    null,
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "SELFIE - CAPTURE",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "selectedIdType": props.selectedIdType.key, "pageName": "SELFIE - CAPTURE", "widgetSessionId": checkinSessionToken },
                    0,
                    false,
                    () => localStorage.setItem("checkin_selfie_capture_event_sent", true)
                );
            }
            props.setCheckinCurrentPageName("SELFIE - CAPTURE")
            
            setShowCameraPrevForId(false);
            setShowCameraPrevForSelfie(true);
        }
    }


    const handleIdSuccess = (imageUri) => {
        if (props.selectedIdType) {
            if (takingBackID && props.selectedIdType.bothSideImageRequired) {
                setMediaFiles({ ...mediaFiles, idImageBackURI: imageUri })
                props.setIdCardImageBack({ imageUrl: `${imageUri}` });
            } else {
                setMediaFiles({ ...mediaFiles, idImageURI: imageUri })
                props.setIdCardImage({ imageUrl: `${imageUri}` });
            }
        } else {
            props.closeOrderPopUp(true, "Please select the id type", "", true)
        }
    }

    const handleSelfieSuccess = (mediaFile, isLast = false) => {

        let files = [...mediaFiles.selfieFiles]
        files.push(mediaFile);
        setMediaFiles({ ...mediaFiles, selfieFiles: files })

        if (isLast) {
            setMediaFiles({ ...mediaFiles, selfiURI: mediaFile })
            props.setSelfieVideo({ videoUrl: `${mediaFile}`, images: files });
        }
    }

    const cameraSuccess = (mediaFile, isLast = false) => {
        if (showCameraPrevForId) {
            handleIdSuccess(mediaFile)
            return;
        }

        if (showCameraPrevForSelfie) {
            handleSelfieSuccess(mediaFile, isLast)
            return;
        }
    }

    useEffect(() => {
        if (props.abortCheckinProcess) {
            goBack();
        }
    }, [props.abortCheckinProcess])

    useEffect(() => {

        scrollToTop();

    }, [])

    return (
        <>
            {(showCameraPrevForId || showCameraPrevForSelfie) ?
                <Camera
                    useExternalCamera={showCameraPrevForId}
                    heading="Guest Check In"
                    idCapture={showCameraPrevForId}
                    selfie={showCameraPrevForSelfie}
                    nextScreen={() => { setShowCameraPrevForId(false); setShowCameraPrevForSelfie(false); }}
                    switchUsingNextScreen={((props.selectedIdType && props.selectedIdType.bothSideImageRequired && props.idCardImageBack && props.idCardImage) || (( !props.selectedIdType || !props.selectedIdType.bothSideImageRequired) && props.idCardImage))}
                    saveImage={cameraSuccess}

                    image={showCameraPrevForSelfie ? mediaFiles.selfiURI : takingBackID ? mediaFiles.idImageBackURI : mediaFiles.idImageURI}

                    backBtn={() => { setShowCameraPrevForId(false); setShowCameraPrevForSelfie(false); }}
                    click_single_picture={showCameraPrevForId}
                    recordVideo={false}
                    hidePicturePreview={() => { setShowCameraPrevForId(false); setShowCameraPrevForSelfie(false); }}
                    selectedId={props.selectedId}
                    messages={showCameraPrevForSelfie && ["Detecting liveliness...", "Taking selfie..."]}
                />
                :
                <div className="main-container">
                    {
                        <header className="inner-pages w-footer subpages ">
                            <a onClick={goBack} className="button-back"></a>
                            <div className="heading align-center">
                                <div class="splash-brand">
                                    <img src={`${CMSPath}${props.logo}`} />
                                </div>
                            </div>
                            <div class="cancel-check-in" onClick={() => { props.cancelCheckinProcess() }}>
                                        <div>Cancel </div>
                                <span style={{}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                </span>
                            </div>
                        </header>
                    }
                    <section className={`widgets padding-0 margin-0 container-bg`} >

                        <div class={`widget-header widget-header-checkin-inner`}>
                            {props.currentWidgetObj.widgetHeaderImageUrl &&
                                <div class="widget-header-img">
                                    <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                                </div>
                            }
                            {
                                <>
                                    <div class="widget-header-title" dangerouslySetInnerHTML={{ __html: props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.identity_verification_heading') : t('check_in.identity_verification_heading') }} ></div>
                                    <div class="widget-header-subtitle" dangerouslySetInnerHTML={{ __html: props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.identity_verification_subheading') : t('check_in.identity_verification_subheading') }} ></div>
                                </>
                            }

                            <div className={`widgets`} >
                                <div className={`form-window`} >
                                    <IdCardCapture setShowCameraPrevForId={(isBackID) => { setTakingBackId(isBackID); openCameraPrev(true, false) }} />
                                    <SelfieCapture setShowCameraPrevForSelfie={() => openCameraPrev(false, true)} />
                                </div>
                            </div>

                            {<>

                                <div className="form-row disclaimer margin-top-2 margin-bottom-2">
                                    {/* <p><span style={{ color: "red" }}>*</span>{t('check_in.keep_straight_face')}</p> */}
                                    {/* <p><span style={{ color: "red" }}>**</span>{t('check_in.remove_objects')}</p> */}
                                    {/* <p><span style={{ color: "red" }}>**</span>{t('check_in.make_sure')}</p> */}
                                </div>

                                <button
                                    className="primary"
                                    disabled={
                                        !props.selfieVideo ||
                                        (props.selectedIdType && props.selectedIdType.bothSideImageRequired
                                            ? (!props.idCardImage || !props.idCardImageBack)
                                            : !props.idCardImage)
                                    }
                                    onClick={props.setConfidanceScreen}
                                >
                                    Continue
                                </button>

                                {DEMO && <button className="secondary w-100 margin-top-1" onClick={props.skip}>SKIP</button>}
                            </>

                            }

                        </div>
                    </section>
                </div>
            }
        </>
    )
}

const mapStateToProps = state => {
    return {
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        selectedIdType: state.store2.selectedIdType,
        idCardImage: state.store2.idCardImage,
        idCardImageBack: state.store2.idCardImageBack,
        idRotateDeg: state.store2.id_rotate_deg,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDocOptions: state.store.guestDocOptions,
        selfieVideo: state.store2.selfieVideo,
        abortCheckinProcess: state.store2.abortCheckinProcess

    }
}

export default connect(mapStateToProps, {
    setIdCardImage,
    setIdCardImageBack,
    setGoHome,
    sendAnalytics,
    setCheckinCurrentPageName,
    closeOrderPopUp,
    setSelectedIdType,
    setSelfieVideo,
    setAbortCheckinProcess

})(withTranslation('translations')(ScanIdandSelfieTogether));